// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"dd18b99b","50":"726abc16","72":"4aaac1c0","73":"fcc9bd35","110":"dbfaefb6","156":"f5f7ddf5","372":"4913a36b","397":"b483fcd9","802":"6ec3a0ca","879":"b90f60dc","917":"2cf65817"}[chunkId] + ".chunk.js";
};